{
  "time_off_attachment_required": "Attach a supporting document.",
  "additional_compensation_amount_negative": "Additional compensation amount cannot be negative",
  "additional_compensation_amount_required": "Enter at least one additional compensation amount",
  "invite_code_invalid": "The code is incorrect. Try again.",
  "impersonation_target_self": "You can't log in as yourself",
  "impersonation_target_privileged": "You can't log in as an employee who also has the log-in-as permission",
  "impersonation_not_active": "This action is only available while logged in as an employee",
  "action_missing_required_fields": "Missing required fields in actions",
  "action_unknown_type": "Only one applicable field should be provided in actions",
  "analytics_data_not_found": "Analytics data not found",
  "applicant_cv_file_type_invalid": "Applicant CV file type invalid",
  "applicant_cv_found": "Applicant CV found",
  "applicant_label_not_found": "Applicant label not found",
  "applicant_not_found": "Applicant not found",
  "applicant_null_names": "Applicant null names",
  "applicant_source_is_custom": "Applicant source is custom",
  "applicant_source_not_found": "Applicant source not found",
  "approval_policy_no_confirming_employees": "No confirming employees assigned to the approval policy",
  "approval_policy_multiple_approvers_require_sequence": "Multiple employees in one approval step are only available for sequential approval",
  "approval_policy_not_assigned": "No approval policy assigned to the employee",
  "approval_request_cant_approve_non_conformation_person": "Approval request can't be approved by non-conformation person",
  "approval_request_cant_be_proceed": "Approval request can't be proceed",
  "approval_request_conformation_not_found": "Approval request conformation not found",
  "approval_request_is_canceled": "Cannot edit a canceled request",
  "approval_request_is_not_approved": "The request is not approved",
  "approval_request_is_not_awaiting": "The request must be in awaiting state to be approved or declined",
  "author_not_found": "Author not found",
  "birthday_display_override_denied": "The format of the employee's birthday display cannot exceed the format set by the organization",
  "blog_attachment_not_found": "The attachment could not be opened. It may have been removed or the link has expired.",
  "calendar_event_attendee_should_contains_at_least_one": "Calendar event must have at least one attendee",
  "calendar_event_attendee_should_contains_one_organizer": "Calendar event must have at least one organizer",
  "calendar_holiday_copy_not_allowed_for_country": "Copying from the previous year isn't available for a calendar with a country — its holidays are synced automatically",
  "calendar_holiday_country_not_provided": "Country is not specified for calendar holidays",
  "calendar_holiday_date_already_exist": "Date already exists in calendar holidays",
  "calendar_holiday_for_location_already_exists": "Calendar holidays not found for location",
  "calendar_holiday_not_found": "Calendar holidays not found",
  "calendar_holiday_years_copy_invalid": "The end year cannot be earlier than the start year",
  "candidate_action_not_found": "Candidate action not found",
  "candidate_action_not_related_to_candidate": "Candidate action is not related to the candidate",
  "candidate_already_exists": "Candidate already exists",
  "candidate_create_error": "Cannot create candidate",
  "candidate_disqualified": "Candidate disqualified",
  "candidate_not_found": "Candidate not found",
  "cant_delete_system_role": "Cannot delete system role",
  "cant_delete_system_source": "Cannot delete system source",
  "cant_delete_system_stage": "Cannot delete system stage",
  "cant_merge_candidates": "Cannot merge candidates. Check candidates' jobs",
  "cant_merge_to_itself": "Cannot merge to itself",
  "cant_update_system_source": "Cannot update system source",
  "career_site_slug_already_exists": "This URL alias is already exists",
  "career_site_slug_wrong_format": "The URL alias can only contain lowercase letters, numbers, and hyphens. Maximum length is 20 characters",
  "comment_and_file": "Comment and file are empty",
  "comment_not_found": "Comment not found",
  "country_not_found": "Country not found",
  "currency_not_found": "Currency not found",
  "custom_field_is_mandatory": "This custom field is mandatory",
  "custom_field_linked_field_not_allowed": "A table can have only one column linked to each employee field",
  "custom_field_title_already_exists": "A field with this name already exists, try changing the field name",
  "custom_fields_wrong_fields_type_to_change": "This custom field cannot be changed",
  "custom_fields_wrong_fields_type_to_set_option": "Options are not allowed for this type of custom field",
  "custom_table_title_already_exists": "A table with this name already exists, try changing the table name",
  "data_protection_access_denied": "Data protection access denied",
  "data_protection_invalid_consent_request": "Invalid data protection consent request",
  "data_protection_settings_disabled": "Data protection settings disabled",
  "data_protection_status_is_not_accepted": "Data protection status is not accepted",
  "department_not_found": "Department not found",
  "disqualification_reason_not_found": "Disqualification reason not found",
  "division_not_found": "Division not found",
  "edit_api_access_denied": "Edit API access denied",
  "edit_candidate_access_denied": "Edit candidate access denied",
  "edit_comment_access_denied": "Edit comment access denied",
  "edit_job_access_denied": "Edit job access denied",
  "email_already_exists": "Email already exists",
  "email_domain_not_allowed": "Only email addresses with an allowed domain can be used for an employee",
  "email_bcc_email_filed_invalid": "BCC email field is invalid",
  "email_cc_email_filed_invalid": "CC email field is invalid",
  "email_integration_not_found": "Email integration not found",
  "email_message_not_found": "Email message not found",
  "email_not_registered": "Email not registered",
  "email_required": "Email is required to send the consent request",
  "employee_not_found": "Employee not found",
  "esign_document_not_pdf": "This document is not a PDF and cannot be used for electronic signature",
  "esign_markup_field_label_required": "Text and Yes/No fields need a label (1 to 500 characters)",
  "esign_markup_field_filled_by_invalid": "Invalid \"filled by\" value for this field type",
  "esign_field_value_required": "This field is required.",
  "esign_field_value_invalid": "This value is not valid.",
  "esign_field_value_unknown": "Unknown field.",
  "esign_envelope_not_pending": "This request is no longer pending and can't be cancelled.",
  "file_conversion_error": "File conversion to PDF was unsuccessful",
  "file_invalid_pdf": "File invalid PDF",
  "file_not_found": "File not found",
  "foreign_key_violation": "Something went wrong on our side. Our team has been notified and is fixing the issue",
  "google_calendar_integration_connect_error": "Unable to connect to Google Calendar",
  "hired_stage_not_found": "Hired stage not found",
  "hiring_plan_approve_reject_access_denied": "Access denied to approve or decline hiring plan",
  "hiring_plan_cancel_access_denied": "Access denied to cancel hiring plan",
  "hiring_plan_connect_job_access_denied": "Access denied to connect job to hiring plan",
  "hiring_plan_create_access_denied": "Access denied to create hiring plan",
  "hiring_plan_delete_access_denied": "Access denied to delete hiring plan",
  "hiring_plan_job_is_already_created": "Hiring plan job is already created",
  "hiring_plan_update_access_denied": "Access denied to update hiring plan",
  "integration_gmail_creds_invalid": "Invalid Gmail credentials. Try to reconnect your account or contact support",
  "integration_gmail_no_email": "Could not retrieve email from Google account",
  "integration_gmail_scope_invalid": "The app can't access some Gmail features. Please reconnect and grant all required permissions",
  "integration_google_auth_no_email": "Email not found in Google auth data",
  "integration_not_found": "Integration not found",
  "integration_smtp_already_exists": "Integration for this email already exists",
  "integration_smtp_auth_failed": "Authentication failed",
  "integration_smtp_auth_failed_imap": "Authentication failed for IMAP",
  "integration_smtp_auth_failed_pop3": "Authentication failed for POP3",
  "integration_smtp_auth_failed_smtp": "Authentication failed for SMTP",
  "integration_not_active": "Integration is disabled. Enable it in the organization settings",
  "integration_zoom_host_not_found": "Your email is not among the users of the company Zoom account. Ask the Zoom admin to add you",
  "integrity_violation": "Something went wrong on our side. Our team has been notified and is fixing the issue",
  "invalid_candidate_date_format": "Invalid candidate date format",
  "invitation_subject_or_body_missing": "Both the subject and the message of the invitation must be either filled in or both left empty",
  "job_is_already_connected_to_hiring_plan": "Job is already connected to hiring plan",
  "job_not_found": "Job not found",
  "level_not_found": "Level not found",
  "link_not_found": "Link not found",
  "location_not_found": "Location not found",
  "login_failed": "Invalid username or password",
  "integration_entra_token_invalid": "Microsoft Entra ID token could not be verified",
  "integration_entra_no_email": "The Microsoft Entra ID account has no work email address",
  "integration_entra_tenant_not_allowed": "Sign-in from this Microsoft Entra ID tenant is not allowed",
  "login_method_oidc_disabled": "Single sign-on is disabled in this organization",
  "integration_oidc_token_invalid": "The single sign-on token could not be verified",
  "integration_oidc_no_email": "The single sign-on account has no email address",
  "integration_oidc_email_not_verified": "The email address of the single sign-on account is not verified",
  "integration_oidc_discovery_failed": "Could not load the OpenID configuration from the issuer URL",
  "integration_oidc_settings_incomplete": "Fill in the issuer URL, client ID and client secret",
  "ip_not_allowed": "Access from your IP address is not allowed by your organization",
  "ip_allowlist_excludes_current_ip": "Your current IP address is not in the list: saving it would lock you out",
  "max_link_lifetime_exceeded": "Maximum link lifetime exceeded",
  "maximum_value_must": "The value must be less than or equal to {maximum}",
  "minimum_value_must": "The value must be greater than or equal to {minimum}",
  "missing_system_stage_in_pipeline": "System stage is missing in pipeline",
  "must_be_integer": "The value must be an integer",
  "must_be_positive": "The value must be positive",
  "must_integer": "The value must be a number",
  "non_unique_pipeline_id": "Candidates are in different pipelines",
  "non_unique_pipeline_stage_type": "Non-unique pipeline stage type",
  "object_not_found": "Oops! We couldn't find requested document",
  "offer_approve_reject_access_denied": "Access denied to approve or decline offer",
  "offer_cancel_access_denied": "Access denied to cancel offer",
  "offer_create_access_denied": "Access denied to create offer",
  "offer_delete_access_denied": "Access denied to delete offer",
  "offer_salary_currency_code_is_missing": "Currency code is required for the offer compensation",
  "offer_salary_value_is_not_decimal": "Value of the offer compensation is not decimal",
  "offer_update_access_denied": "Access denied to update offer",
  "only_author_can_change_owners": "Only the author can change the list of co-owners",
  "organization_module_disabled": "Module is disabled",
  "organization_not_found": "Organization not found",
  "organization_settings_not_found": "Organization settings not found",
  "password_must_contain_lowercase": "Password must contain at least one lowercase letter",
  "password_must_contain_number": "Password must contain at least one number",
  "password_must_contain_special": "Password must contain at least one special character",
  "password_must_contain_uppercase": "Password must contain at least one uppercase letter",
  "performance_review_not_exists_or_not_running": "The performance review either does not exist or is not running",
  "performance_review_reopen_not_allowed": "Only completed performance reviews can be reopened",
  "pipeline_not_found": "Pipeline not found",
  "pipeline_or_disqualification_reason_need": "Pipeline or disqualification reason is required",
  "pipeline_stage_not_found": "Pipeline stage not found",
  "position_employee_not_found": "Position employee not found",
  "position_not_enough_data": "Position not enough data",
  "position_not_found": "Position not found",
  "reference_still_exists": "Related objects exist. Remove all related objects before deleting",
  "request_validation_failed": "Request validation failed",
  "required_field_missing": "Field is required",
  "required_source_id": "Required source ID",
  "reset_password_limit_exceeded": "Reset password limit exceeded",
  "reset_password_token_expired": "This link has expired. Please request a new one",
  "reset_password_token_invalid": "Reset password token invalid",
  "reviewer_addition_not_allowed": "Adding peers is only allowed for reviewer types that support manual peer assignment",
  "reviewer_types_limit_exceeded": "The maximum number of reviewer types has been exceeded",
  "role_not_found": "Role not found",
  "secure_password_not_strong": "Password must contain numbers, lowercase and uppercase letters, and special characters",
  "secure_password_to_short": "Password is too short",
  "secure_previous_password_equal": "Password matches the previous one",
  "subdomain_already_exists": "Subdomain already exists",
  "survey_anonymous_cant_change": "Can't change anonymous threshold for survey with completed responses",
  "survey_answer_file_delete_not_allowed": "This file cannot be deleted",
  "survey_answer_file_duplicate": "The same file cannot be attached twice",
  "survey_answer_file_invalid": "This file cannot be used in the survey answer",
  "survey_answer_file_not_found": "The attached file was not found",
  "survey_answer_file_too_large": "The file must not exceed 20 MB",
  "survey_answer_files_limit_exceeded": "You can attach up to 5 files",
  "survey_not_exists_or_not_running": "The survey either does not exist or is not running",
  "survey_reopen_not_allowed": "Only completed surveys can be reopened",
  "tfa_failed": "Incorrect two-factor authentication code entered",
  "tfa_wrong_code": "Wrong code",
  "time_off_approve_reject_access_denied": "Access denied to approve or decline time off",
  "approval_policy_time_off_categories_not_allowed": "Time off types can only be set for a time off approval category",
  "approval_policy_time_off_category_not_found": "Time off type not found",
  "time_off_asked_date_from_less_then_min_notice_period": "The requested start date is earlier than the minimum notice period allows.",
  "time_off_asked_date_from_less_then_today": "The requested start date is earlier than today.",
  "time_off_asked_date_from_more_then_max_notice_period": "The requested start date is beyond the maximum notice period.",
  "time_off_asked_less_then_min_daily_amount": "The requested amount is less than the minimum allowed daily amount.",
  "time_off_asked_less_then_min_request_total": "The total requested amount is below the minimum allowed value.",
  "time_off_asked_more_then_max_request_total": "The total requested amount exceeds the maximum allowed value.",
  "time_off_cannot_create_overlapped_time_off_requests": "Cannot create time-off requests that overlap in time",
  "time_off_cannot_create_time_off_requests_in_probation": "Time off is not available during probation",
  "time_off_data_required": "Time off data is required",
  "time_off_no_approval_policy": "No approval policy is associated with this request.",
  "time_off_not_enough_days": "Insufficient days available to complete this request.",
  "time_off_not_enough_hours": "Insufficient hours available to complete this request.",
  "time_off_policy_accrual_frequency_data_required": "Time off policy accrual frequency data is required",
  "time_off_policy_carryover_cycle_date_data_required": "Time off policy carryover cycle date data is required",
  "time_off_request_date_from_has_passed": "The start date of the time off request has passed",
  "too_wide_filter_for_candidates": "Too wide filter for candidates",
  "unique_key_violation": "Something went wrong on our side. Our team has been notified and is fixing the issue",
  "view_api_access_denied": "View API access denied",
  "wrong_mass_action_filter": "Filter should be either pipeline stages or disqualification reasons",
  "wrong_request_type": "Something went wrong on our side. Our team has been notified and is fixing the issue",
  "~": "~",
  "user_cant_edit_task": "Edit task access denied",
  "task_not_found": "Task not found",
  "folder_not_found": "Folder not found",
  "user_cant_edit_folder": "Edit folder access denied",
  "user_cant_delete_folder": "Delete folder access denied",
  "user_cant_create_document": "Create document access denied",
  "user_cant_edit_document": "Edit document access denied",
  "user_cant_delete_document": "Delete document access denied",
  "time_off_policy_effective_from": "Effective date cannot be in the past",
  "portal_access_already_released": "The restriction has already been lifted manually and can't be brought back",
  "portal_access_workflow_not_started": "The flow didn't start. Please try again.",
  "hiring_flow_block_mandatory": "This step is mandatory in the hiring template",
  "hiring_flow_block_disabled": "This step is disabled in the hiring template",
  "hiring_flow_workflows_locked": "The flows selected in the hiring template cannot be changed",
  "compensation_after_probation_requires_probation": "Compensation after probation requires a probation end date",
  "probation_ends_before_hired_on": "The probation end date cannot be before the start date",
  "custom_field_unknown_slug": "This field is unavailable in the hiring form",
  "employee_hire_idempotency_key_reused": "This hiring form was already submitted with different data. Reopen the hiring form and try again",
  "employee_hire_failed": "Could not hire the employee",
  "processing_job_not_found": "The task was not found",
  "ai_job_description_empty": "Add a job description to generate requirements",
  "ai_job_description_too_short": "Job description is too short to generate requirements"
}
